import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "operate-row" }

import { SmsVerifyService } from './sms-verify.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { User } from '@/services/user'
import { computed, onUnmounted, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize } from '@/components/cmForm/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'sms-verify',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  confirmButtonText: {
    type: String,
    default: '',
  },
  headText: {
    type: String,
    default: '',
  },
  tipsText: {
    type: String,
    default: '',
  },
  /** 使用当前绑定的手机，同时电话输入框不可编辑 */
  useCurrentPhone: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "confirm", "close"],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const { t, locale } = useI18n()

const injector = useReflectiveInjector([SmsVerifyService])
const smsVerifyService = injector.get(SmsVerifyService)
const userService = injector.get(User)

const formRef = ref<InstanceType<typeof CmForm>>()
/** 等待验证码时长 0-60 */
const codeWaitSecond = ref(0)

const formData = reactive({
  phone: '',
  code: '',
})

const dialogTitle = computed(() => props.headText || t('smsVerify.defaultTitle'))
const confirmText = computed(() => props.confirmButtonText || t('common.confirm'))

const formColumns = computed(() => {
  void locale.value

  return {
    phone: {
      hiddenAllLabel: true,
      placeholder: t('smsVerify.phonePlaceholder'),
      colOpt: { span: 24 },
      inputOpt: { readonly: props.useCurrentPhone },
      rules: [{ required: true, message: t('smsVerify.phoneRequired'), trigger: 'blur' }],
    },
    code: {
      hiddenAllLabel: true,
      slot: true,
      colOpt: { span: 24 },
      rules: [{ required: true, message: t('smsVerify.verifyCodeRequired'), trigger: 'blur' }],
    },
  }
})

userService.userInfo.subscribe(res => {
  if (props.useCurrentPhone) {
    formData.phone = res.mobile?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') ?? ''
  }
})

watch(
  () => props.useCurrentPhone,
  (useCurrent) => {
    if (!useCurrent) {
      formData.phone = ''
    }
  },
)

async function checkBeforeSendCode () {
  try {
    await formRef.value?.ruleFormRef?.validateField('phone')
    return true
  } catch {
    return false
  }
}

async function handleClickSendCode () {
  if (!await checkBeforeSendCode()) {
    return
  }

  const apiPromise = props.useCurrentPhone
    ? smsVerifyService.sendCodeUid.bind(smsVerifyService)
    : smsVerifyService.sendCode.bind(smsVerifyService)
  apiPromise(formData.phone).then(() => {
    startCodeSecondTimer()
  })
}

async function handleConfirm () {
  if (!await formRef.value?.handleSubmit()) {
    return
  }
  emits('confirm', { ...formData })
}

function handleClose () {
  resetData()
  emits('update:modelValue', false)
  emits('close')
}

function resetData () {
  formRef.value?.handleReset()
  codeWaitSecond.value = 0
}

/** 开始验证码倒数计时 */
function startCodeSecondTimer () {
  codeWaitSecond.value = 60
  const intervalMillisecond = 1000
  const createTimer = () => {
    setTimeout(() => {
      codeWaitSecond.value--
      if (codeWaitSecond.value > 0) {
        createTimer()
      }
    }, intervalMillisecond)
  }
  createTimer()
}

onUnmounted(() => {
  handleClose()
})

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    "custom-class": "sms-verify-dialog sms-verify-wrap",
    title: dialogTitle.value,
    width: "470px",
    "model-value": __props.modelValue,
    "close-on-click-modal": false,
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      (__props.tipsText)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 0,
            class: "tip-alert",
            title: __props.tipsText,
            type: "warning",
            closable: false,
            "show-icon": ""
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(CmForm, {
        ref_key: "formRef",
        ref: formRef,
        modelValue: formData,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData) = $event)),
        formSize: _unref(FormSize).Small,
        formType: _unref(FormActionType).Other,
        "onUpdate:formType": _cache[2] || (_cache[2] = ($event: any) => ((_unref(FormActionType).Other) = $event)),
        formColumns: formColumns.value,
        formOpt: { 'label-width': '0px', skipSubmitMsg: true }
      }, {
        code: _withCtx(() => [
          _createVNode(_component_el_input, {
            size: "small",
            class: "code-input",
            modelValue: formData.code,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.code) = $event)),
            placeholder: _unref(t)('smsVerify.verifyCodePlaceholder')
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_el_button, {
            size: "small",
            class: "button-code",
            disabled: codeWaitSecond.value !== 0,
            onClick: handleClickSendCode
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(codeWaitSecond.value === 0
              ? _unref(t)('smsVerify.getVerifyCode')
              : _unref(t)('smsVerify.verifyCodeCountdown', { n: codeWaitSecond.value })), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue", "formSize", "formType", "formColumns"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(confirmText.value), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value"]))
}
}

})